import api from 'tim-api';
import { location, address, cities as citiesEndPoint } from 'endPoints';

export const state = {
  states: [],
  cities: []
};

export const getters = {
  states: ({ states }) => states,
  getPlaceById: ({ places }) => id => id && places.find(place => place.id === id),
  cities: ({ cities }) => cities,
  getCityById: ({ cities }) => id => id && cities.find(city => city.city_id === id)
};

export const mutations = {
  SET_CITIES(state, cities) {
    state.cities = cities;
  },
  SET_LOCATION(state, payload) {
    state.location = payload;
  }
};

export const actions = {
// eslint-disable-next-line
  fetchLocation({ commit },address) {
    return api.get(location + address)
      .then(({ data }) => data.data)
      .catch(error => error);
  },
  fetchCitiesSync({ commit }, uf) {
    return api.get(`${citiesEndPoint}${uf}`)
      .then(({ data }) => data.data);
  },
  fetchCities({ commit }, uf) {
    return api.get(`${citiesEndPoint}${uf}`)
      .then(({ data }) => {
        commit('SET_CITIES', data.data);
      });
  },
  // eslint-disable-next-line
  fetchAddressByCep({commit},cep) {
    return api.get(`${address}${cep}`).then(({ data }) => data.data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
